import validate from "/code/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/code/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "check-auth": () => import("/code/middleware/checkAuth.js"),
  "check-auth-provider": () => import("/code/middleware/checkAuthProvider.js"),
  "check-logged-in": () => import("/code/middleware/checkLoggedIn.js")
}